import styled from 'styled-components/macro';

import { Checkbox, TextButton, Input } from 'components';

import NextIcon from 'assets/icons/next-right';
import ArrowLinkIcon from 'assets/icons/arrow-link';

export const NextIconStyled = styled(NextIcon)`
  padding-left: 4px;
  padding-top: 1px;
`;

export const ButtonGroupStyled = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const MessageStyled = styled.div`
  ${({ theme: { colors = {}, spacing } = {}, customMargin }) => `
    color: ${colors.grey?.darker};
    margin-bottom: ${customMargin || `${spacing?.(3)}`};
  `};
`;

export const TextButtonStyled = styled(TextButton)`
  ${({ theme: { spacing } = {}, customMargin, isEmailMessage }) => `
    margin-bottom: ${customMargin || `${spacing?.(3)}`};
    ${
      isEmailMessage &&
      `
      margin-top: ${spacing?.(4.5)};
      text-align: center;
    `
    };
  `};
`;

export const InputStyled = styled(Input)`
  width: 40%;
`;

export const ArrowLinkStyled = styled(ArrowLinkIcon)`
  margin-left: 4px;
`;

export const SubTitleStyled = styled.div`
  ${({ theme: { colors = {}, spacing, typography } = {} }) => `
    ${typography?.(16)}
    color: ${colors.grey?.darker};
    margin-bottom: ${spacing?.(4)};
    width: 100%;
  `};
`;

export const CheckboxStyled = styled(Checkbox)`
  ${({ theme: { spacing } = {} }) => `
    display: block;
    margin-bottom: ${spacing?.(4)};
    margin-left: 0;
  `};
`;
